/** Tipos de e-commerces do cliente */
export interface ClienteECommerceTipo {
    id: number;
    nome: string;
}

export const eCommerceTipoEcommerce: ClienteECommerceTipo = {id: 1, nome: 'E-commerce'};
export const eCommerceTipoMercadoLivre: ClienteECommerceTipo = {id: 2, nome: 'Mercado Livre'};
export const eCommerceTipoMarketplace: ClienteECommerceTipo = {id: 3, nome: 'Marketplace'};


export const tiposEcommerces: ClienteECommerceTipo[] = [
    eCommerceTipoEcommerce,
    eCommerceTipoMercadoLivre,
    eCommerceTipoMarketplace
];
